module.exports = __webpack_public_path__ + "static/media/label-5.d44f6bc8.svg";